import styled from "styled-components";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";

export const StyledNavMain = styled(Nav.Link)`
  padding-bottom: 0px;
  font-weight: bold;
`;

export const StyledNavSub = styled(Nav.Link)`
  color: rgba(0, 0, 0, 1);
  padding-top: 0px;
  padding-bottom: 0px;
`;
export const StyledLink = styled(NavLink)`
  text-decoration: none;
  color: #000000 !important;
  font-weight: bold;
  margin: 0.5rem 0.5rem 0.5rem 0.5rem;
  &.active {
    border-bottom: 1px solid #000000;
  }
`;

export const HeaderSpan = styled.span`
  @media (max-width: 425px) {
    display: none;
  }
`;
